import useFeatureFlags from 'hooks/useFeatureFlags'
import type React from 'react'
import { EMARMedicationStockScreenV2 } from '../ResidentEmarV2Screens/EMARMedicationStockScreenV2'
import { EMARMedicationStockScreen } from './EMARMedicationStockScreen'

const EMARMedicationStockScreenWrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_stock'] })?.data

  const newEmarEnabled = flags?.emar_v2_stock?.enabled ?? false

  if (newEmarEnabled) {
    return <EMARMedicationStockScreenV2 />
  }

  return <EMARMedicationStockScreen />
}

export default EMARMedicationStockScreenWrapper
